import { useQuery, UseQueryResult, QueryOptions } from '@tanstack/react-query'

import { getTemplateInformation } from '@pepper/utils/src/api/editor/editor'

interface Argument {
  id: string
}

export function useTemplateInformation(
  { id }: Argument,
  config?: QueryOptions<TemplateDetails | null | undefined, Error>
): UseQueryResult<TemplateDetails | null | undefined, Error> {
  return useQuery({
    queryKey: [`/template/${id}`],
    queryFn: async () => {
      const response = await getTemplateInformation({ id })
      if (response.error) {
        throw response.error
      } else {
        return response.data
      }
    },
    ...config
  })
}
